import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/jay/Repos/gaoljie/use-swiper/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import useSwiper from "../src";
import "../src/example.scss";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "navigation"
    }}>{`Navigation`}</h1>
    <Playground __position={0} __code={'() => {\n  const { ref } = useSwiper({ loop: true, navigation: true })\n  return (\n    <div ref={ref}>\n      <div>1</div>\n      <div>2</div>\n      <div>3</div>\n      <div>4</div>\n      <div>5</div>\n    </div>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      useSwiper,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const {
          ref
        } = useSwiper({
          loop: true,
          navigation: true
        });
        return <div ref={ref}>
        <div>1</div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
      </div>;
      }}
    </Playground>
    <h1 {...{
      "id": "custom-navigation"
    }}>{`Custom Navigation`}</h1>
    <Playground __position={1} __code={'() => {\n  const { ref } = useSwiper({\n    arrowLeft: <span style={{ fontSize: \'50px\' }}> {\'<\'} </span>,\n    arrowRight: <span style={{ fontSize: \'50px\' }}> {\'>\'} </span>,\n  })\n  return (\n    <div ref={ref}>\n      <div>1</div>\n      <div>2</div>\n      <div>3</div>\n      <div>4</div>\n      <div>5</div>\n    </div>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      useSwiper,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const {
          ref
        } = useSwiper({
          arrowLeft: <span style={{
            fontSize: "50px"
          }}> {"<"} </span>,
          arrowRight: <span style={{
            fontSize: "50px"
          }}> {">"} </span>
        });
        return <div ref={ref}>
        <div>1</div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
      </div>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      